import { Injectable } from '@angular/core';
import { ErrorMessageType } from '../../shared/enum';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() { }

  public generateErrorMessage(type: ErrorMessageType) {
    const error = new Array<string>();
    switch (type) {
      case ErrorMessageType.General: {
        error.push('Ein allgemeiner Fehler ist aufgetreten.');
      }
      break;
      case ErrorMessageType.OffertLoad: {
        error.push('Das Angebot konnte nicht geladen werden.');
      }
      break;
      case ErrorMessageType.OffertCreate: {
        error.push('Das Angebot konnte nicht erstellt werden.');
      }
      break;
      case ErrorMessageType.AntragCreate: {
        error.push('Der Antrag konnte nicht erstellt werden.');
      }
      break;
      case ErrorMessageType.CalculateRate: {
        error.push('Die Prämie konnte nicht berechnet werden.');
      }
      break;
      case ErrorMessageType.Eurotax: {
        error.push('Die Eurotax-Abfrage ist derzeit nicht verfügbar, Sie können Ihre Fahrzeugdaten stattdessen manuell eingeben.');
      }break;
      case ErrorMessageType.EurotaxService: {
        error.push('Die Eurotax-Abfrage ist derzeit nicht verfügbar, Nach dem Klick auf „Abbrechen“ können Sie Ihre Fahrzeugdaten manuell eingeben.');
      }break;
    }

    error.push('Wir bitten um etwas Geduld und versichern Ihnen: Bald ist alles wieder im grünen Bereich!');
    error.push('Gerne können Sie uns einen Hinweis an <a href="mailto:onlineservice@hdi.at">onlineservice@hdi.at</a> schicken. Danke für Ihre Unterstützung!');

    return error.join('\n');
  }
}
